module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0126.jpg?v=b9882011";